import React, { useRef, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useTranslations } from '../../../../../shared/src/hooks/use-translations.hook';
import { GridPageStripContent } from '../GridPageStripContent';
import { WinnersStrip } from '../../Winners/WinnersStrip';
import './GridPageStripWinners.css';
import { useCallbackOnInitAndResizeHook } from '../../../../../shared/src/hooks/use-callback-on-init-and-resize.hook';

export const GridPageStripWinners = () => {
    const [wrapperWidth, setWrapperWidth] = useState(0);
    const wrapperRef = useRef(null);
    const { winnersStripConfig } = useSelector((state) => state.app.config);
    const { t } = useTranslations();

    const updateWrapperWidth = useCallback(() => {
        setWrapperWidth(wrapperRef?.current?.offsetWidth);
    }, [wrapperRef, setWrapperWidth]);
    useCallbackOnInitAndResizeHook({ callback: updateWrapperWidth, testLog: true });

    if (!winnersStripConfig?.showStrip) {
        return null;
    }

    const stripTitle = t('winners');

    return (
        <GridPageStripContent
            headerTitle={stripTitle}
            ref={wrapperRef}
        >
            <WinnersStrip parentWidth={wrapperWidth} />
        </GridPageStripContent>
    );
};
